/**
 * Route Parameter Encoder/Decoder
 * 
 * Encodes route IDs so they are not human-readable in the browser URL bar.
 * This prevents casual URL manipulation. 
 * 
 * NOTE: This is a frontend obfuscation layer only. 
 * True security MUST be enforced on the backend via authorization checks.
 */

const SALT = "dmrc_sq_";

export const encodeRouteParam = (id: string | number): string => {
    try {
        const raw = SALT + String(id);
        return btoa(raw)
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
    } catch {
        return String(id);
    }
};

export const decodeRouteParam = (encoded: string): string => {
    try {
        // Restore base64 padding and chars
        let b64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
        while (b64.length % 4 !== 0) b64 += "=";
        const decoded = atob(b64);
        if (decoded.startsWith(SALT)) {
            return decoded.slice(SALT.length);
        }
        // If it doesn't have the salt, return as-is (backwards compat for old URLs)
        return encoded;
    } catch {
        // If decoding fails, treat it as a plain ID (backwards compatibility)
        return encoded;
    }
};
